import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getMotorColorStart,
  getMotorColorSuccess,
  getMotorColorFailure,
} from "../reducers/getMotorColorReducer";
import axios from "axios";
import Cookies from "js-cookie";

export const getMotorColor = createAsyncThunk(
  "getMotorColor",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getMotorColorStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Motor/GetColor`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getMotorColorSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getMotorColorFailure(error.response.data.Message));

      throw error;
    }
  }
);
